import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {faceOffRunUrl} from './getFaceOffRun'
import {FaceOffVerdictRequest} from './types'

/** Saves one verdict: POST /v2/faces/faceoff/runs/{runId}/verdicts. */
export const postFaceOffVerdict = (
  http: HttpInstance,
  runId: string,
  body: FaceOffVerdictRequest,
): Promise<AxiosResponse<unknown>> =>
  http.request<unknown>({
    method: 'POST',
    url: `${faceOffRunUrl(runId)}/verdicts`,
    data: body,
  })
